<script setup lang="ts">
import ContractManagement from 'src/components/contract-management/ContractManagement.vue';
</script>

<template>
  <ContractManagement />
</template>
